<template>
  <div></div>
</template>

<script>
export default {
  name: 'JobOpenings',
  props: {
    jobs: { type: Array, default: () => [] }
  }
}
</script>

<style scoped>
</style>
